import {setRouterConfigurations} from 'core/react-router'
import {localeCodes} from '../utils/localization'
import NotFound from '../../apps/front-office/home/components/NotFound'

setRouterConfigurations({
  localeCodes: localeCodes,
  basePath: '/',
  notFound: {
    mode: 'render',
    component: NotFound,
  },
})
